var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("App mount failure")]),_c('p',[_vm._v("The app failed to lauch, see the browser console for more details.")]),_c('p',[_vm._v(" If reloading the browser does not fix the issue please contact the site administrator. ")])])
}]

export { render, staticRenderFns }